import { api } from "@/lib/api/client";
import type { Invitee, Meeting, Page, Recurrence, Role } from "@/lib/api/types";

export type MeetingInput = {
  title: string;
  description?: string;
  startsAt: string;
  endsAt: string;
  timezone: string;
  recurrence?: Recurrence;

  roomId?: string;
  invitees?: { email: string; role?: Role }[];
};

export function listMeetings(
  query: { from?: string; to?: string; status?: string; cursor?: string } = {},
): Promise<Page<Meeting>> {
  return api<Page<Meeting>>("meetings", { query });
}

export function createMeeting(input: MeetingInput): Promise<Meeting> {
  return api<Meeting>("meetings", { method: "POST", body: input });
}

export function getMeeting(id: string): Promise<Meeting> {
  return api<Meeting>(`meetings/${id}`);
}

export function updateMeeting(id: string, input: Partial<MeetingInput>): Promise<Meeting> {
  return api<Meeting>(`meetings/${id}`, { method: "PATCH", body: input });
}

export function cancelMeeting(id: string): Promise<void> {
  return api<void>(`meetings/${id}`, { method: "DELETE" });
}

export function addInvitees(
  meetingId: string,
  input: { emails: string[]; role?: Role; message?: string },
): Promise<Invitee[]> {
  return api<Invitee[]>(`meetings/${meetingId}/invites`, { method: "POST", body: input });
}

export function removeInvitee(meetingId: string, inviteId: string): Promise<void> {
  return api<void>(`meetings/${meetingId}/invites/${inviteId}`, { method: "DELETE" });
}
